import { AppState } from '@chegg-wt/core/state'
import { adConfigVersionSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { getCookie, Cookies } from '@chegg-wt/core/utils/cookies'

const getAllocationMap = (state: AppState) => {
  const archieCookie = Cookies.AdLayout
  const archieCell = adConfigVersionSelector(state) || getCookie(archieCookie)
  let allocationMap = []

  /* eslint-disable no-underscore-dangle */
  if (archieCell) {
    allocationMap = [{ layer: archieCookie, cell: archieCell }]
  } else if (window._sbmArchieAllocator) {
    // from allocator script for nonWT sites
    const sbmArchieAllocator = window._sbmArchieAllocator
    allocationMap =
      sbmArchieAllocator.cookie && sbmArchieAllocator.cell
        ? [{ layer: sbmArchieAllocator.cookie, cell: sbmArchieAllocator.cell }]
        : []
  }

  return allocationMap
}

export default getAllocationMap
